import React from 'react'
import { connect } from 'react-redux';
import delay from 'lodash/delay';
import Api, { AuthEvents } from './api/Api.js';
import NotificationEndpoints from './api/NotificationEndpoints';
import { store } from './redux/store';
import { UPDATE_NOTIFICATIONS } from './redux/types';

class NotificationWatcher extends React.Component {

    checkNotifications = async () => {
        var latestId = 0;
        if (this.props.notifications && this.props.notifications.length > 0) {
            var sortedNotifications = [].concat(this.props.notifications.sort((x, y) => x.id > y.id ? 1 : -1));
            latestId = sortedNotifications.pop().id;
        }

        var result = await Api.get(NotificationEndpoints.checkLatest, { id: latestId });

        if(!result) {
            return;
        }

        var { data } = result;

        if (data.length > 0)
            store.dispatch({ type: UPDATE_NOTIFICATIONS, payload: data });

        this.notificationTimer = setTimeout(this.checkNotifications, 1000);
    }

    // state = {
    //     connection: null
    // }

    // configureConnection = async () => {
    //     this.setState({ connection: Api.socket(NotificationHub) },
    //         () => {
    //             this.state.connection
    //                 .start()
    //                 .then(() => {
    //                     console.log("Connected to Notification");
    //                     this.state.connection.on("ReceivedNotification", (notification) => store.dispatch({ type: UPDATE_NOTIFICATIONS, payload: notification }))
    //                 })
    //                 .catch((e) => {
    //                     console.error("Failed to Connect to Notification Watcher", e);
    //                 })
    //         });
    // }

    notificationTimer;
    componentDidMount() {
        if (Api.isLoggedIn() && !Api.isLocked()) {
            this.checkNotifications();
        }

        AuthEvents.on("loggedIn", () => {
            delay(() => this.checkNotifications, 1000);
        })

        AuthEvents.on("loggedOut", () => {
            clearTimeout(this.notificationTimer)
        })
    }

    componentWillUnmount = () => {
        clearTimeout(this.notificationTimer)
    }

    render = () => null;
}

const mapStateToProps = (state) => {
    return {
        notifications: state.notifications
    };
}

export default connect(mapStateToProps)(NotificationWatcher);